import { Controller } from "stimulus";
import {removeHtmlElementClass} from "../utils/utils";


export default class extends Controller {
    static targets = [ "quantity" ];

    handleSave() {
        if (parseInt(this.quantityTarget.value) > 100)
            removeHtmlElementClass(document, "loading_overlay", "d-none");
    }
}